import { render, staticRenderFns } from "./ChannelDetails.vue?vue&type=template&id=8a649bac&scoped=true&"
import script from "./ChannelDetails.vue?vue&type=script&lang=js&"
export * from "./ChannelDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChannelDetails.vue?vue&type=style&index=0&id=8a649bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a649bac",
  null
  
)

export default component.exports